import React from 'react';

export const EqTsunamiModal = {
  title: 'Associated Tsunami or Seiche',
  body: (
    <div>
      <p>
        When a tsunami or seiche was generated by an earthquake, An icon appears in the Associated Tsunami column which is linked to the tsunami event database. The link will display additional tsunami event information.
      </p>
    </div>
  ),
};
